module.exports = __webpack_public_path__ + "img/driver-earnings-graph.png";